export default __webpack_public_path__ + "static/media/asset_management.ce975b3c.png";